import { useEffect, useState } from "react"
import { DocumentationResponsePayload, DocumentationSpecification, PokalRequestLocation } from "pokal_api"
import notNull from "../util/notNull"

function APIDocumentationView() {

    const [docs, setDocs] = useState<DocumentationResponsePayload | null>(null)

    useEffect(() => {
        DocumentationSpecification.request().then(res => (
            setDocs(res)
        ))
    }, [])
    
    function methodColor(location: PokalRequestLocation): string {
        switch (location.method) {
            case "GET":
                return "bg-green-300 text-green-800"
            case "POST":
                return "bg-blue-300 text-blue-800"
            case "PUT":
                return "bg-yellow-300 text-yellow-800"
            case "DELETE":
                return "bg-red-300 text-red-800"
        }
    }

    return (
        <div className={"w-full flex items-center justify-center"}>
            <div className={"w-screen max-w-[800px]"}>
                <div className={"p-4 flex flex-col"}>
                    {notNull(docs) ? (
                        <div className={"flex-col space-y-10"}>
                            {docs.map((d, index) => (
                                <div key={index} className={"flex flex-col space-y-4 bg-white p-2 rounded shadow"}>
                                    <div className={"flex space-x-4 items-center"}>
                                        <div className={"w-20 h-10 font-bold flex items-center justify-center rounded " + (methodColor(d.location))}>
                                            {d.location.method}
                                        </div>
                                        <div className={"w-[400px] h-10 flex items-center"}>{d.location.path}</div>
                                    </div>
                                    <div className={"w-[200px] h-10 italic"}>{d.authenticated ? "Requires authentication" : "No authentication required"}</div>
                                    <div>{d.description}</div>
                                </div>
                            ))}
                        </div>
                    ) : <div>Dokumentation lädt ...</div>}
                </div>
            </div>
        </div>
    )
}

export default APIDocumentationView